const verifyHkid = (hkid) => {
  const regex1 = new RegExp('^[A-Z]{1,2}[0-9]{6}([0-9A])$');
  const regex2 = new RegExp('^[A-Z]{1,2}[0-9]{6}[0-9A]$');

  return regex1.test(hkid) || regex2.test(hkid);
};

export const extractHkid = (str) => {
  if (typeof str !== 'string' || str.length === 0) {
    return '';
  }
  let prefixLength = 0;
  // 判断开头是 2 个字母
  if (str.length >= 2 && /^[a-zA-Z]{2}/.test(str)) {
    prefixLength = 2;
  } else if (str.length >= 1 && /^[a-zA-Z]/.test(str)) {
    prefixLength = 1;
  } else {
    return '';
  }
  // 计算要截取的总长度：prefixLength + 7
  const totalLength = prefixLength + 7;
  // 如果字符串长度不足，截取到末尾
  if (str.length < totalLength) {
    return str.substring(0, str.length);
  } else {
    return str.substring(0, totalLength);
  }
};

export default verifyHkid;
